import store from '@/store'
import _ from 'lodash'
import wtsTools from '@/static/js/wtsTools.esm.min.js'
const tools = wtsTools.tools

const onOrientationchange = _.debounce(
  function() {
    window.lib.flexible.refreshRem()
    store.commit('setCurrentOrientationType', getOrientationType())
  },
  tools.isMobile() ? 16 : 500,
)

/**
 * 开启屏幕方向监听
 */
export function watchScreen() {
  if (window.onorientationchange) {
    window.addEventListener('orientationchange', onOrientationchange, true)
  } else {
    window.addEventListener('resize', onOrientationchange, true)
  }
}

/**
 * IOS Safari
 * window.orientation | screen.orientation.angle | screen.orientation.type
 * 0 | 0 | portrait-primary | 向上竖屏
 * 90 | 270 | landscape-secondary | 向左横屏
 * -90 | 90 | landscape-primary | 向右横屏
 *
 * Android 三星浏览器
 * window.orientation | screen.orientation.angle | screen.orientation.type
 * 0 | 0 | portrait-primary | 向上竖屏
 * 90 | 90 | landscape-primary | 向左横屏
 * -90 | 270 | landscape-secondary | 向右横屏
 */

/**
 * 获取屏幕旋转方向
 * @returns {OrientationType}
 */
export function getOrientationType() {
  let orientationType = 'portrait-primary'
  const angle = getOrientationAngle()
  switch (angle) {
    case 0:
      // 向上竖屏
      orientationType = 'portrait-primary'
      break
    case 90:
      // 向左横屏
      orientationType = 'landscape-primary'
      break
    case -90:
      // 向右横屏
      orientationType = 'landscape-secondary'
      break
    case 180:
      // 向下竖屏
      orientationType = 'portrait-secondary'
      break
  }
  console.log('<orientationType>', orientationType)
  return orientationType
}

// 获取横竖屏状态
export function getOrientationStatu() {
  let orientationStatus = ''
  let orientation = window.matchMedia('(orientation: portrait)')
  if (orientation.matches) {
    orientationStatus = '竖屏'
  } else {
    orientationStatus = '横屏'
  }
  return orientationStatus
}

/**
 * 获取屏幕旋转角度
 * @returns {0|90|-90|180}
 */
export function getOrientationAngle() {
  let angle = 0
  if (navigator.userAgent.includes('HeyTapBrowser')) {
    angle = getOrientationStatu() == '竖屏' ? 0 : 90
    console.log('欢太浏览器,不支持获取屏幕角度', angle)
    return angle
  }
  try {
    angle = screen.orientation.angle
    console.log('screen.orientation.angle', screen.orientation.angle)
    // if (tools.isIOS()) {
    //   if (angle === 0) {
    //     angle = 0
    //   } else if (angle === 270) {
    //     angle = 90
    //   } else if (angle === 90) {
    //     angle = -90
    //   } else {
    //     angle = 180
    //   }
    // } else {
    //   if (angle === 0) {
    //     angle = 0
    //   } else if (angle === 90) {
    //     angle = 90
    //   } else if (angle === 270) {
    //     angle = -90
    //   } else {
    //     angle = 180
    //   }
    // }
  } catch (e) {
    angle = window.orientation
    console.log('window.orientation', window.orientation)
  }
  console.log('<angle>', angle)
  return angle
}
